import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import { logout } from './redux/authSlice';
import Header from './pages/Header';
import Footer from './pages/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';

import ProtectedRoute from './pages/ProtectedRoute';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import Help from './pages/Help';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import NotFound from './pages/NotFound';
import Services from './pages/Services';
import Pricing from './pages/Pricing';
import MobileView from './pages/MobileView';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import AgriStackPage from './pages/AgriStackPage';
import CancellationAndRefundPolicy from './pages/CancellationAndRefundPolicy';
import TransactionSummary from './pages/TransactionSummary';
import NewHomePage from './pages/NewHomePage';
import NewContactUs from './pages/newContactUs';
import BlogSelfHelpGroup from './pages/BlogSelfHelpGroup';
import Careers from './pages/Careers';
import ExperienceCertificate from './pages/ExperienceCertificate';
import BgMitraPrivacyPolicy from './pages/bg-mitra/PrivacyPolicy';
import WebSignup from './pages/WebSignup';
import NewAgriStackPage from './pages/NewAgriStackPage';
function App() {
  const [globalToast, setGlobalToast] = React.useState({ show: false, message: '', type: 'success' });

  React.useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    const handleToastEvent = (event) => {
      setGlobalToast({
        show: true,
        message: event.detail.message,
        type: event.detail.type
      });
    };

    const handleJwtExpired = () => {
      store.dispatch(logout());
    };

    document.addEventListener('contextmenu', handleContextMenu);
    window.addEventListener('show-toast', handleToastEvent);
    window.addEventListener('jwt-expired', handleJwtExpired);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      window.removeEventListener('show-toast', handleToastEvent);
      window.removeEventListener('jwt-expired', handleJwtExpired);
    };
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <div className="App d-flex flex-column min-vh-100">
            <Header />
            <main className="flex-grow-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/help" element={<Help />} />
                <Route path="/services" element={<Services />} />
                <Route path="/pricing" element={<Pricing />} />
                {/* <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                <Route path="/recharge" element={<ProtectedRoute><Recharge /></ProtectedRoute>} /> */}
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/farmer" element={<ProtectedRoute><AgriStackPage /></ProtectedRoute>} />
                <Route path="/bg-mitra" element={<MobileView />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/cancellation-and-refund-policy" element={<CancellationAndRefundPolicy />} />
                <Route path="*" element={<Home />} />
                <Route path="/navnath/vedant/test/vakralabs/transaction-summary" element={<ProtectedRoute><TransactionSummary /></ProtectedRoute>} />
                <Route path="/navnath/vedant/test/vakralabs/signup" element={<ProtectedRoute ><WebSignup/> </ProtectedRoute>} />
                <Route path="/navnath/vedant/test/vakralabs/farmer" element={<ProtectedRoute ><NewAgriStackPage/> </ProtectedRoute>} />
                {/* <Route path="/new-page" element={<NewHomePage />} />
                <Route path="/new-contact" element={<NewContactUs />} /> */}
                <Route path="/blog/shg" element={<BlogSelfHelpGroup />} />
                <Route path="/careers" element={<Careers />} />
                 <Route path="/experience-certificate" element={<ExperienceCertificate />} />
                 <Route path="/bgmitra/privacy-policy" element={<BgMitraPrivacyPolicy />} />

              </Routes>
            </main>
            <Footer />
            {globalToast.show && (
              <div className="position-fixed top-0 end-0 m-3" style={{ zIndex: 1050 }}>
                <div className={`toast show`}>
                  <div className={`toast-header bg-${globalToast.type === 'error' ? 'danger' : 'success'} text-white`}>
                    <strong className="me-auto">{globalToast.type === 'error' ? 'Error' : 'Success'}</strong>
                    <button type="button" className="btn-close btn-close-white" onClick={() => setGlobalToast({ ...globalToast, show: false })}></button>
                  </div>
                  <div className="toast-body">
                    {globalToast.message}
                  </div>
                </div>
              </div>
            )}
          </div>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
